import {fetchFileMetadata} from "../../utils/dashboardCalls";

const mockResponse = {
    "version": "1.2",
    "message": "Hello World",
    "result": {
        "host_types": [
            {"id": 1, "mnemonic": "unix", "count": 35903909},
            {"id": 2, "mnemonic": "mswin", "count": 8358353},
            {"id": 3, "mnemonic": "mac", "count": 8532}
        ],
        "file_type": [
            {"id": 190, "mnemonic": "idb", "extension": ".idb", "group": "databases", "count": 3589351},
            {"id": 191, "mnemonic": "sql", "extension": ".sql", "group": "databases", "count": 3589351},
            {"id": 286, "mnemonic": "c++", "extension": ".c", "group": "dev", "count": 3589349},
            {"id": 6, "mnemonic": "python", "extension": ".py", "group": "dev", "count": 1289538},
            {"id": 7, "mnemonic": "segd", "extension": ".segd", "group": "seismic", "count": 1289538},
            {"id": 8, "mnemonic": "segy", "extension": ".segy", "group": "seismic", "count": 1289538}
        ],
        "file_group": [
            {"id": 11, "mnemonic": "databases", "count": 28989235},
            {"id": 14, "mnemonic": "dev", "count": 12346925},
            {"id": 9, "mnemonic": "seismic", "count": 346925},
        ],
        "hosts": [
            {"id": 116, "hostname": "vindicator", "flavour": "unix", "count": 3848315},
            {"id": 117, "hostname": "liberator", "flavour": "mswin", "count": 2884222},
            {"id": 118, "hostname": "alligator", "flavour": "mac", "count": 8}
        ],
        "backup_software": [
            {"id": 1, "mnemonic": "nbu", "name": "NetBackup", "count": 593831},
            {"id": 2, "mnemonic": "commvault", "name": "CommVault", "count": 38583},
            {"id": 3, "mnemonic": "geo", "name": "GeoPhysical Backups", "count": 0},
            {"id": 4, "mnemonic": "tar", "name": "UNIX TAR", "count": 0}
        ],
        "retention_policies": [
            {"id": 1, "label": "Indefinite", "description": "retain indefinitely", "action": "keep", "retention_years": 9999, "retention_months": 0},
            {"id": 2, "label": "7yrpurge", "description": "retain for seven years after backup", "action": "delete", "retention_years": 7, "retention_months": 0},
            {"id": 3, "label": "21yrarchive", "description": "retain for twenty one years after backup, then archive", "action": "archive", "retention_years": 21, "retention_months": 0}
        ],
        "backup_dates": [
            {"id": 1, "description": "first", "value": "2002-06-07 14:35:12"},
            {"id": 2, "description": "last", "value": "2025-06-13 07:12:23"}
        ],
        "common_users": [
            {"username": "ovidiu", "id": 6935832},
            {"username": "chris", "id": 5024985},
            {"username": "henry", "id": 7029482},
            {"username": "ruby", "id": 12384092}
        ],
        "common_groups": [
            {"group_name": "staff", "id": 13953842},
            {"group_name": "pets", "id": 23857285}
        ]
    }
}

const mockDataRetriever = (setRawSupportData, setLoading) => {
    const second = 1000;
    const mockDelay = 0.5 * second;
    setLoading(true);
    const handle = setTimeout(() => {
        setRawSupportData({...mockResponse?.result});
        setLoading(false);
    }, mockDelay);
};
const fileFiltersDataRetriever = (setRawSupportData, setLoading) => {
    setLoading(true);

    fetchFileMetadata()
        .then(data => {
            setRawSupportData(data || {});
            setLoading(false);
        })
        .catch(error => {
            console.error("Error fetching file metadata:", error);
            setRawSupportData([]);
            setLoading(false);
        });
};

export const variantDataRetrieverMapFilters = {
    defValue: mockDataRetriever,
    fileFilters: fileFiltersDataRetriever,
}